module.exports = __webpack_public_path__ + "img/empty.27ae7055.png";